<template>
    <section class="section-hero section-shaped my-0">
        <div class="shape shape-style-1 shape-primary">
            <span class="span-150"></span>
            <span class="span-50"></span>
            <span class="span-50"></span>
            <span class="span-75"></span>
            <span class="span-100"></span>
            <span class="span-75"></span>
            <span class="span-50"></span>
            <span class="span-100"></span>
            <span class="span-50"></span>
            <span class="span-100"></span>
        </div>
        <div class="container shape-container d-flex align-items-center">
            <div class="col px-0">
                <div class="row justify-content-center align-items-center">
                    <div class="col-lg-7 text-center pt-lg">
                        <img src="img/brand/KoomKahLogo.png" style="width: 200px;" class="img-fluid"><br>
                        <a class="lead text-white mt-1 mb-1" >เข้าใช้งานระบบธนาคารขยะ คุ้มค่า</a><br>
                        <div> <br><br><br>  </div>
                        <img href="mailto://koomkah@gmail.com" src="img/prd/linelogo.png" style="width: 40px;"><a href="http://nav.cx/oZdsD5"> Line @Koomkah</a><br>
                        <div> <br><br><br>  </div>
                        <img href="https://web.facebook.com/koomkah" src="img/prd/fb_icon_325x325.png" style="width: 40px;">
                        <div> <br><br><br>  </div>
                        <a href="https://web.facebook.com/koomkah"> Facebook @Koomkah</a><br><br><br><br>
                        <a href="mailto://koomkah@gmail.com">&#9993; Koomkah@gmail.com</a><br><br><br> 
                        
                        <div class="btn-wrapper">
                            <base-button tag="a"
                                         href="https://admin.koomkah.com"
                                         class="mb-3 mb-sm-0"
                                         type="info"
                                         icon="ni ni-key-25">
                                จัดการธนาคาร
                            </base-button>
                            <base-button tag="a"
                                         href="https://bank.koomkah.com"
                                         class="mb-3 mb-sm-0"
                                         type="info"
                                         icon="ni ni-mobile-button">
                                พนักงานธนาคาร
                            </base-button>
                            
                        </div>
                    </div>
                </div>
                <div class="row align-items-center justify-content-around stars-and-coded">
                    <div class="col-sm-4 mt-4 mt-sm-0 text-right">
                        <span class="text-white alpha-7">&copy; 2019</span>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>

export default {

}
</script>
<style>
</style>
